// extracted by mini-css-extract-plugin
module.exports = {"container":"Unauthorized_container__DfeSv"};